// THIS IS AN AUTOGENERATED FILE.  DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'styled-components';
import { useIconSize } from '../useIconSize';
import { jsx as _jsx } from "react/jsx-runtime";
export const DragHandleIcon = ({
  size = 'inherit',
  color = 'inherit',
  'aria-label': ariaLabel,
  id
}) => {
  const theme = useTheme();
  const sizeValue = useIconSize(size);
  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // currentColor = color of the parent element

  return /*#__PURE__*/_jsx("svg", {
    width: sizeValue,
    height: sizeValue,
    fill: colorValue,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "DragHandle",
    children: /*#__PURE__*/_jsx("path", {
      d: "M12 2h2.01c.55 0 1 .45 1 1v2.01c0 .55-.45 1-1 1H12c-.55 0-1-.45-1-1V3c0-.55.45-1 1-1m0 6h2.01c.55 0 1 .45 1 1v2.01c0 .55-.45 1-1 1H12c-.55 0-1-.45-1-1V9c0-.55.45-1 1-1m0 6h2.01c.55 0 1 .45 1 1v2.01c0 .55-.45 1-1 1H12c-.55 0-1-.45-1-1V15c0-.55.45-1 1-1m0 6h2.01c.55 0 1 .45 1 1v2.01c0 .55-.45 1-1 1H12c-.55 0-1-.45-1-1V21c0-.55.45-1 1-1m6-18h2.01c.55 0 1 .45 1 1v2.01c0 .55-.45 1-1 1H18c-.55 0-1-.45-1-1V3c0-.55.45-1 1-1m0 6h2.01c.55 0 1 .45 1 1v2.01c0 .55-.45 1-1 1H18c-.55 0-1-.45-1-1V9c0-.55.45-1 1-1m0 6h2.01c.55 0 1 .45 1 1v2.01c0 .55-.45 1-1 1H18c-.55 0-1-.45-1-1V15c0-.55.45-1 1-1m0 6h2.01c.55 0 1 .45 1 1v2.01c0 .55-.45 1-1 1H18c-.55 0-1-.45-1-1V21c0-.55.45-1 1-1m-6 5.99h2.01c.55 0 1 .45 1 1V29c0 .55-.45 1-1 1H12c-.55 0-1-.45-1-1v-2.01c0-.55.45-1 1-1m6 0h2.01c.55 0 1 .45 1 1V29c0 .55-.45 1-1 1H18c-.55 0-1-.45-1-1v-2.01c0-.55.45-1 1-1"
    })
  });
};